export const Navbar = () => {
  return (
    <header className="head_part">
      <div className="portfolio_name">
        <a href="#home" id="logo">Portfolio...</a>
      </div>
      <nav className="navbar">
        <a href="#home" style={{"--i": "1"}}>Home</a>
        <a href="#about" style={{"--i": "2"}}>About Me</a>
        <a href="#skills" style={{"--i": "3"}}>My Skills</a>
        <a href="#projects" style={{"--i": "4"}}>My Projects</a>
        <a href="#contact" style={{"--i": "5"}}>Contact Me....!</a>
      </nav>
    </header>
  );
};